import { useEffect, useState } from 'react';
import { subscribeComercialPorEmail } from '../services/comercialesClientesService';

/**
 * Clientes asignados al usuario logueado como empleado comercial, según el padrón
 * `comercialesClientes` que sincroniza la Cloud Function con el Sistema de
 * Gestión Comercial.
 *
 * Se llama con el email del personal interno y con `null` en cualquier otro caso
 * (productores, sin sesión), así no se abre la suscripción.
 *
 * Devuelve { comercial, isLoading }:
 * - isLoading: true hasta que Firestore responde para ESE email (se deriva del
 *   email de la respuesta, así el render en que aparece el usuario no informa
 *   "no figura" antes de leer). El rol y el Dashboard dependen de esto.
 * - comercial: el documento del padrón, o null si el usuario no figura como
 *   empleado comercial en el SGC.
 *
 * Es una suscripción en vivo: si le asignan un cliente nuevo en el SGC, aparece
 * en la corrida siguiente sin recargar la planilla.
 */
export const useComercialClientes = (email) => {
    const [state, setState] = useState({ email: null, comercial: null });

    useEffect(() => {
        if (!email) return undefined;
        return subscribeComercialPorEmail(
            email,
            (comercial) => setState({ email, comercial }),
            // Si la lectura falla no se puede saber el alcance: se deja de cargar
            // como si no figurara en el padrón.
            () => setState({ email, comercial: null }),
        );
    }, [email]);

    if (!email) return { comercial: null, isLoading: false };
    const respondio = state.email === email;
    return { comercial: respondio ? state.comercial : null, isLoading: !respondio };
};
